import { useEffect, useRef, useState } from "react";

import styles from "./TaskTitle.module.css";

// The task's title, in the breadcrumb and only there. Click to edit; Enter /
// blur commits, Escape reverts. A no-op change (blank or unchanged) doesn't hit
// the server.
export const TaskTitle = ({
  onRename,
  title,
}: {
  readonly onRename: (title: string) => void;
  readonly title: string;
}) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(title);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [editing]);

  const commit = (): void => {
    setEditing(false);
    const next = draft.trim();
    if (next.length > 0 && next !== title) {
      onRename(next);
    }
  };

  if (editing) {
    return (
      <input
        aria-label="Task title"
        className={styles.input}
        onBlur={commit}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            commit();
          } else if (e.key === "Escape") {
            setEditing(false);
          }
        }}
        ref={inputRef}
        value={draft}
      />
    );
  }
  return (
    <button
      className={styles.button}
      onClick={() => {
        setDraft(title);
        setEditing(true);
      }}
      // The full title, since the button ellipsizes it.
      title={title}
      type="button"
    >
      {title}
    </button>
  );
};
